// src/pages/Dashboard/StatsBox.js
import React from "react";
import useChatbotStats from "./useChatbotStats";
import { CircularProgress, Box, Typography } from "@mui/material";


export default function StatsBox() {
    const { stats, error, loading } = useChatbotStats();

    if (loading) return (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress size={24} />
            <Typography sx={{ ml: 2 }}>Loading stats...</Typography>
        </Box>
    );
    
    if (error) return <div className="alert alert-warning">{error}</div>;
    if (!stats) return <div>No stats available for this chatbot.</div>;

    return (
        <div>
            <div className="row">
                {/* Private Documents Stats */}
                <div className="col-sm-6 col-xl-3">
                    <div className="card card-2">
                        <div className="card-body">
                            <div className="row">
                                <div className="col mt-0">
                                    <h5 className="card-title">Number of Files</h5>
                                </div>
                                <div className="col-auto">
                                    <div className="stat text-primary">
                                        <i className="fa fa-file-o"></i>
                                    </div>
                                </div>
                            </div>
                            <h1 className="mt-1 mb-3">{stats.privateDocs.total_documents}</h1>
                            <div className="mb-0">
                                <span className="badge badge-success-light">{stats.privateDocs.total_page_characters}</span>
                                <span className="text-muted"> chars, </span>
                                <span className="badge badge-success-light">{stats.privateDocs.total_page_words}</span>
                                <span className="text-muted"> words, </span>
                                <span className="badge badge-success-light">{stats.privateDocs.total_tokens}</span>
                                <span className="text-muted"> tokens.</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Website Links Stats */}
                <div className="col-sm-6 col-xl-3">
                    <div className="card card-2">
                        <div className="card-body">
                            <div className="row">
                                <div className="col mt-0">
                                    <h5 className="card-title">No. of Website Links</h5>
                                </div>
                                <div className="col-auto">
                                    <div className="stat text-primary">
                                        <i className="fa fa-link"></i>
                                    </div>
                                </div>
                            </div>
                            <h1 className="mt-1 mb-3">{stats.websiteLinks.total_links}</h1>
                            <div className="mb-0">
                                <span className="badge badge-success-light">{stats.websiteLinks.total_page_characters}</span>
                                <span className="text-muted"> chars, </span>
                                <span className="badge badge-success-light">{stats.websiteLinks.total_page_words}</span>
                                <span className="text-muted"> words, </span>
                                <span className="badge badge-success-light">{stats.websiteLinks.total_tokens}</span>
                                <span className="text-muted"> tokens.</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Total Words */}
                <div className="col-sm-6 col-xl-3">
                    <div className="card card-2">
                        <div className="card-body">
                            <div className="row">
                                <div className="col mt-0">
                                    <h5 className="card-title">Total Words</h5>
                                </div>
                                <div className="col-auto">
                                    <div className="stat text-primary">
                                        <i className="fa fa-font"></i>
                                    </div>
                                </div>
                            </div>
                            <h1 className="mt-1 mb-3">{stats.totalWords}</h1>
                            <div className="mb-0">
                                <span className="text-muted">
                                    Total chars: 
                                    <span className="badge badge-success-light"> {stats.totalCharacters} </span>, 
                                    tokens: 
                                    <span className="badge badge-success-light"> {stats.totalTokens} </span>.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Total Tokens (This card is specific to the selected chatbot) */}
                <div className="col-sm-6 col-xl-3">
                    <div className="card card-2">
                        <div className="card-body">
                            <div className="row">
                                <div className="col mt-0">
                                    <h5 className="card-title">Chatbot Used Tokens</h5>
                                </div>
                                <div className="col-auto">
                                    <div className="stat text-primary">
                                        <i className="fa fa-comment"></i>
                                    </div>
                                </div>
                            </div>
                            <h1 className="mt-1 mb-3">{stats.tokens.total_total_token}</h1>
                            <div className="mb-0">
                                <span className="text-muted">Input: </span>
                                <span className="badge badge-success-light">{stats.tokens.total_input_tokens} </span>
                                <span className="text-muted">, Output: </span> 
                                <span className="badge badge-success-light">{stats.tokens.total_output_tokens} </span>.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}